import { gql } from 'apollo-angular';

export const KPI_MASTER_QUERY = gql`
  query kpisMasters {
    kpisMasters {
      id
      name
    }
  }
`;

export const PLAYER_COMPETITION_KPI_QUERY = gql`
  query PlayerCompetitionKpis($filter: PlayerCompetitionKpisInput) {
    playerCompetitionKpis(filter: $filter) {
      competitionId
      seasonId
      kpiMasterId
      playerId
      value
      clubId
    }
  }
`;

export const PLAYER_GAME_KPI_QUERY = gql`
  query PlayerGameKpis($filter: PlayerGameKpisInput) {
    playerGameKpis(filter: $filter) {
      gameId
      kpiMasterId
      playerId
      value
    }
  }
`;

export const PLAYER_ROLE_KPI_QUERY = gql`
  query PlayerRoleKpis($filter: PlayerRoleKpisInput) {
    playerRoleKpis(filter: $filter) {
      roleMasterId
      gameId
      kpiMasterId
      playerId
      value
    }
  }
`;

export const TEAM_COMPETITION_KPI_QUERY = gql`
  query TeamCompetitionKpis {
    teamCompetitionKpis {
      id
      competitionId
      seasonId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const TEAM_GAME_KPI_QUERY = gql`
  query TeamGameKpis($filter: TeamGameKpisInput) {
    teamGameKpis(filter: $filter) {
      gameId
      kpiMasterId
      teamId
      value
    }
  }
`;

export const TEAM_ROLE_KPI_QUERY = gql`
  query TeamRoleKpis {
    teamRoleKpis {
      id
      gameId
      formationMasterId
      kpiMasterId
      teamId
      value
      inPossession
    }
  }
`;

export const TEAM_GAME_KPIS = gql`
  query TeamGameKpis($filter: TeamGameKpisInput!) {
    teamGameKpis(filter: $filter) {
      gameId
      kpiMasterId
      teamId
      value
    }
  }
`;
